(function () {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /*
     * The activeFormUtilities service is useful for managing information about which
     * form is currently active where a page may have more than one form, and forms
     * need to behave a specific way when they are not the form that the user is
     * interacting with.
     */
    angular
        .module('ihh-common-web')
        .service('activeFormUtilities', activeFormUtilities);

    activeFormUtilities.$inject = ['$rootScope'];

    function activeFormUtilities($rootScope) {
        var self = this;
        var activeForm = '';

        /*
         * This function sets the active form.
         * @param {String} formName - form name to set as active form
         */
        self.setActiveForm = function (formName) {
            if (angular.isString(formName)) {
                activeForm = formName;
            }
        };

        /*
         * This function gets the active form that is set.
         * @return {String} activeForm - the active form
         */
        self.getActiveForm = function () {
            return activeForm;
        };

        /*
         * This function clears the active form.
         */
        self.clearActiveForm = function () {
            activeForm = '';
        };

        /*
         * This function indicates if there is no active form set.
         * @return {Boolean} noActiveForm - is there no active form?
         */
        self.hasNoActiveForm = function () {
            return angular.isString(activeForm) && activeForm.length === 0;
        };

        /*
         * This function returns true if the form controls should be enabled.
         * This is true if there is no active form, or the passed name matches the
         * active form
         * @param {String} formName - the form name to check
         * @return {Boolean} enabledFormControls - returns true if the form is active;
         *  false otherwise (with the exception noted above)
         */
        self.enabledFormControls = function (formName) {
            if (self.hasNoActiveForm()) {
                return true; // there is no active form
            }

            return formName === activeForm;
        };

        // ensure that when the user leaves the current page, we do not remember which form was set as active.
        $rootScope.$on('$routeChangeSuccess', function () {
            self.clearActiveForm();
        });
    }
})();